<template>
  <panel
    :icon="'play'"
    :heading="labelToDisplay"
  >
    <template v-if="$store.getters['flashcardStates/lastUpdatedAt']['flashcards']">
      <template v-if="gettingStartedMode">
        <div class="text">
          Answer Your First Question
        </div>
        <button @click="goToQuickStart">
          Quick start
        </button>
      </template>
      <template v-else>
        <template v-if="lastState.flashcard">
          <router-link :to="{name: 'categories#index', params: lastState.params, query: {nav: lastState.query}}">
            {{ lastState.name }}
          </router-link>
        </template>
        <template v-else-if="lastState.mnemonic">
          <router-link :to="{name: 'mnemonics#show', params: lastState.params, query: {nav: lastState.query}}">
            {{ lastState.name }}
          </router-link>
        </template>
        <template v-else>
          No recent items
        </template>
      </template>
    </template>
  </panel>
</template>

<script>
import Panel from '@components/singletons/panel';

export default {
  components: { Panel },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    quickStartItem() {
      return this.$store.getters['navigationItems/menuItems'].filter(x => {
        return x.destination === 'flashcard_categories';
      })[0];
    },
    flashcardStateList() {
      return this.$store.getters['flashcardStates/flashcardStateList'];
    },
    gettingStartedMode() {
      const states = this.flashcardStateList;
      return states.length === 0 && this.quickStartItem;
    },
    labelToDisplay() {
      if (!this.$store.getters['flashcardStates/lastUpdatedAt']['flashcards']) {
        return '';
      }
      if (this.gettingStartedMode) {
        return 'GET STARTED HERE';
      } else {
        return this.label;
      }
    },
    lastMnemonicState() {
      let state = Object.values(this.$store.getters['mnemonicStates/mnemonicStates']).sort((a, b) => b.mobileCreatedAt - a.mobileCreatedAt)[0];
      if(state) {
        let category = this.$store.getters['categories/all'].find(c => c.id == state.categoryId) || {};
        let navItem = this.$store.getters['navigationItems/menuItems'].find(ni => ['mnemonic_categories', 'mnemonics'].includes(ni.destination) && ni.resourceId == category.categoryTypeId);
        if(category && navItem) {
          return {time: state.mobileCreatedAt, mnemonic: true, name: category.name, query: navItem.query, destination: navItem.destination, params: {categoryId: category.id, mnemonicId: state.id }};
        }
      }
      return {};
    },
    lastFlashcardState() {
      let items = this.$store.getters['navigationItems/menuItems'].filter(ni => ['flashcard_categories'].includes(ni.destination));
      let ids = this.$store.getters['categories/all'].filter(c => items.map(ni => ni.resourceId).includes(c.categoryTypeId)).map(c => c.id);
      let state = Object.values(this.$store.getters['flashcardStates/flashcardStates']).filter(fs => ids.includes(fs.categoryId)).sort((a, b) => b.mobileCreatedAt - a.mobileCreatedAt)[0];
      if(state) {
        let category = this.$store.getters['categories/all'].find(c => c.id == state.categoryId) || {};
        let navItem = items.find(ni => ['flashcard_categories'].includes(ni.destination) && ni.resourceId == category.categoryTypeId);
        let name = category.name;
        category = category.children.length > 0 ? category : this.$store.getters['categories/categories'][category.parentCategoryId];
        if(category && navItem) {
          return {time: state.mobileCreatedAt, flashcard: true, name: name, query: navItem.query, destination: navItem.destination, params: {categoryId: category.id }};
        }
      }
      return {};
    },
    lastState() {
      if(!this.lastFlashcardState.time) {
        return this.lastMnemonicState;
      } else if(!this.lastMnemonicState.time) {
        return this.lastFlashcardState;
      } else {
        return this.lastFlashcardState.time > this.lastMnemonicState.time ? this.lastFlashcardState : this.lastMnemonicState;
      }
    },
  },
  methods: {
    goToQuickStart() {
      this.$router.push({name: 'categories#flashcard', params: {categoryId: 'all'}, query: {nav: this.quickStartItem.query}});
    },
  },
};
</script>

<style lang='scss' scoped>
  a {
    color: #354052;

    &:hover {
      text-decoration: underline;
    }
  }
  .text {
    color: #354052;
    font-size: rem-calc(18);
    margin-bottom: rem-calc(20);
  }
  button {
    text-align: right;
    width: rem-calc(120);
    height: rem-calc(34.5);
    background-color: #00d0dc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: rem-calc(16);
    float: right;
    border: none;
    cursor: pointer;
    font-weight: 600;
    margin-bottom: rem-calc(15);
  }
</style>
